<template>

    <div class="checkbox-group" :style="styles">
        <slot></slot>
    </div>

</template>

<style scoped lang="scss">

    .checkbox-group {
        display: flex;
        > * {
            margin: 0 15px 5px 0;
        }
    }

</style>

<script>

export default {

    props: {
        flexDirection: {
            type: String,
            default: 'column',
        },
    },

    computed: {

        styles() {
            return {
                'flex-direction': this.flexDirection,
            };
        },

    },

}

</script>